import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ReactNode, memo } from 'react';
import { Pressable, View } from 'react-native';

/** One style option: its name, its fields, and a way back to the theme. */
export const StyleGroup = memo(
  ({
    title,
    onReset,
    children,
  }: {
    title: string;
    /** Given while the card sets this option itself. */
    onReset?: (() => void) | null;
    children: ReactNode;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        style={{
          gap: rpx(8),
          paddingVertical: rpx(10),
          borderTopWidth: 1,
          borderTopColor: aiColors.border,
        }}
      >
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography.Text medium size={rpx(12)} color={aiColors.foreground}>
            {title}
          </Typography.Text>
          {onReset ? (
            <Pressable
              accessibilityRole="button"
              accessibilityLabel={`${title}恢复默认`}
              hitSlop={8}
              onPress={onReset}
            >
              <Typography.Text size={rpx(11)} color={aiColors.primary}>
                恢复默认
              </Typography.Text>
            </Pressable>
          ) : null}
        </View>
        {children}
      </View>
    );
  },
);
